import { render, staticRenderFns } from "./AlertHeatmap.vue?vue&type=template&id=15352674&scoped=true&"
import script from "./AlertHeatmap.vue?vue&type=script&lang=js&"
export * from "./AlertHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./AlertHeatmap.vue?vue&type=style&index=0&id=15352674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15352674",
  null
  
)

export default component.exports